import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Button } from './Button';
export function PricingSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-white py-20 md:py-32 px-4" data-id="element-147">
      <div className="max-w-4xl mx-auto" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-149">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-[#3A3A3A] mb-6 leading-tight" data-id="element-150">
            La parte que más cambia todo (y nadie espera)
          </h2>
          <p className="text-xl text-[#5A5A5A] max-w-3xl mx-auto leading-relaxed" data-id="element-151">
            Este método no te vuelve "una persona ordenada". Te vuelve una
            persona que <strong data-id="element-152">no se hunde</strong> cuando la semana se pone
            fea.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {
        opacity: 0,
        scale: 0.95
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="bg-[#F5F1E8] rounded-2xl p-8 md:p-12 text-center" data-id="element-153">
          <p className="text-lg text-[#5A5A5A] mb-6" data-id="element-154">
            Porque incluso en tu peor día, puedes hacer:
          </p>
          <ul className="space-y-2 text-[#3A3A3A] mb-8 text-lg" data-id="element-155">
            <li data-id="element-156">• basura afuera</li>
            <li data-id="element-157">• encimera despejada</li>
            <li data-id="element-158">• lavabo reset</li>
            <li data-id="element-159">• ropa al cesto</li>
          </ul>
          <p className="text-xl font-medium text-[#3A3A3A]" data-id="element-160">
            Y eso evita el colapso.
          </p>
        </motion.div>

        <motion.div id="pricing" initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="mt-16 bg-gradient-to-br from-[#7B9FAB] to-[#6A8E9A] rounded-2xl p-8 md:p-12 text-center text-white shadow-2xl" data-id="element-161">
          <div className="mb-8" data-id="element-162">
            <p className="text-lg mb-2 opacity-90" data-id="element-163">Acceso completo por</p>
            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-164">
              <span className="text-3xl md:text-4xl font-bold line-through opacity-60" data-id="element-165">
                $19
              </span>
              <span className="text-6xl md:text-7xl font-bold" data-id="element-166">$6.39</span>
            </div>
            <p className="text-lg mt-4 opacity-90" data-id="element-167">
              Menos que una salida rápida. Y te devuelve algo que vale más:{' '}
              <strong data-id="element-168">silencio mental en tu casa.</strong>
            </p>
          </div>

          <Button onClick={() => {
          window.location.href = 'https://www.simpleymejor.com/cart/46654273749169:1';
        }} className="bg-[#C17B6B] hover:bg-[#B06A5A] text-white text-xl px-12 py-5" data-id="element-169">
            Obtener Reset de 15 Minutos
          </Button>

          <p className="text-sm mt-6 opacity-75" data-id="element-170">
            Descarga inmediata • PDF + imprimibles • Acceso de por vida
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {
        opacity: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="mt-12 text-center" data-id="element-171">
          <p className="text-[#5A5A5A] italic" data-id="element-172">
            No necesitas convertirte en otra persona para tener una casa
            manejable. Necesitas una rutina que funcione cuando estás cansada.
          </p>
        </motion.div>
      </div>
    </section>;
}